export enum ReferralUpdatedBy {
  'AWS' = 'AWS',
  'LABRA_CRM' = 'Labra CRM',
}

export type ReferralMetadataType = 'referral_lead' | 'referral_opportunity'

export enum COSELL_ACTIONS {
  SET_REFERRALS = 'SET_REFERRALS',
  SET_DASHBOARD_METRICS = 'SET_DASHBOARD_METRICS',
  SET_REFERRALS_METRICS = 'SET_REFERRALS_METRICS',
  SET_AWS_PRODUCTS = 'FETCH_AWS_PRODUCTS',
  SET_PARTNER_CENTRAL_USER_DETAILS = 'SET_PARTNER_CENTRAL_USER_DETAILS',
  SET_SOLUTION_OFFERED_OPTIONS = 'SET_SOLUTION_OFFERED_OPTIONS',
  SET_REFERRAL_FORM_FIELDS = 'SET_REFERRAL_FORM_FIELDS',
  CLEAR_REFERRALS_DATA = 'CLEAR_REFERRALS_DATA',
  SET_SHOW_ALL_FIELDS = 'SET_SHOW_ALL_FIELDS',
  SET_CATEGORIES_WITH_NO_FIELDS = 'SET_CATEGORIES_WITH_NO_FIELDS',
  SET_TEST_OPPORTUNITY = 'SET_TEST_OPPORTUNITY',
  SET_FILTERS = 'SET_FILTERS',
  SET_AGENT_RECOMMENDATIONS = 'SET_AGENT_RECOMMENDATIONS',
  SET_ACTIVE_AGENT_DRAWER = 'SET_ACTIVE_AGENT_DRAWER',
  CLEAR_ACTIVE_AGENT_DRAWER = 'CLEAR_ACTIVE_AGENT_DRAWER',
}

export type ReferralFormField = {
  dataType: string
  disableInCreation?: boolean
  disableInUpdate?: boolean
  hideInCreation?: boolean
  id: string
  info?: string
  isRequired?: boolean
  maxLength?: number
  placeholder?: string
  title: string
}
